document.addEventListener('DOMContentLoaded', function() {

    /*Section what can you do*/
    if($('.swiperWhatCanMain').length > 0) {
        let swiperWhatCanTumbnl = new Swiper('.swiperWhatCanTumbnl', {
            breakpoints: {
                320: {
                    slidesPerView: 4.1,
                    freeMode: true,
                },
                700: {
                    slidesPerView: 7,
                    spaceBetween: 10,
                }
            },
            centeredSlides: true,
            loop: true,
            clickable: true,
            effect: 'slide',
            slideActiveClass: 'active',
            pagination: {
                el: ".swiper-pagination.swiper-what-can-text-pagination-custom",
                dynamicBullets: true,
            },
            on: {
                slideChange: function () {
                    if ($(document).width() > 700) {
                        document.querySelectorAll('.swiperWhatCanTumbnl .swiper-slide img').forEach((img, index) => {
                            let scale = 0.6; // Default small size
                            if (index === this.activeIndex) scale = 1; // Center image largest
                            else if (index === this.activeIndex - 1 || index === this.activeIndex + 1) scale = 0.9;
                            else if (index === this.activeIndex - 2 || index === this.activeIndex + 2) scale = 0.7;

                            img.style.transform = `scale(${scale})`;
                        });
                    } else {
                        document.querySelectorAll('.swiperWhatCanTumbnl .swiper-slide img').forEach((img, index) => {
                            let scale = 0.75; // Default small size
                            if (index === this.activeIndex) scale = 1; // Center image largest
                            else if (index === this.activeIndex - 1 || index === this.activeIndex + 1) scale = 0.9;
                            else if (index === this.activeIndex - 2 || index === this.activeIndex + 2) scale = 0.8;

                            img.style.transform = `scale(${scale})`;
                        });
                    }

                }
            }
        });
        let swiperWhatCanMain = new Swiper('.swiperWhatCanMain', {
            slidesPerView: 1,
            loop: true,
            spaceBetween: 10,
            effect: 'slide',
            thumbs: {
                swiper: swiperWhatCanTumbnl,
            },
        });

        let swiperWhatCanText = new Swiper('.swiperWhatCanText', {
            slidesPerView: 1,
            loop: true,
            spaceBetween: 10,
            effect: 'slide',
            thumbs: {
                swiper: swiperWhatCanTumbnl,
            },
            navigation: {
                nextEl: ".swiperWhatCanText .swiper-button-next",
                prevEl: ".swiperWhatCanText .swiper-button-prev",
            },
        });

        swiperWhatCanMain.on('slideChangeTransitionEnd', function () {
            const activeIndex = $('.swiperWhatCanMain .swiper-slide-active').data('swiper-slide-index');
            swiperWhatCanText.slideToLoop(activeIndex);
        });

        swiperWhatCanText.on('slideChange', function () {
            setTimeout(function () {
                const activeMainSlider = $('.swiperWhatCanText .swiper-slide-active').data('swiper-slide-index');
                swiperWhatCanTumbnl.slideToLoop(activeMainSlider);
                swiperWhatCanMain.slideToLoop(activeMainSlider);
            }, 100);
        });

        swiperWhatCanTumbnl.on('sliderMove', function (sliderMoved) {
            setTimeout(function () {
                const activeMainSlider = $('.swiperWhatCanTumbnl .active').data('swiper-slide-index');
                swiperWhatCanMain.slideToLoop(activeMainSlider);
                swiperWhatCanText.slideToLoop(activeMainSlider);
            }, 100);
        });
    }

    /*Customer reviews section*/
    if($('.pdp-reviews-section').length > 0) {
        setTimeout(function () {
            let currentValue = $('.pdp-reviews-section .jdgm-rev-widg__summary-average').text();
            currentValue = currentValue.replace("out of 5", "");
            currentValue = currentValue.trim();
            $('.pdp-reviews-section .jdgm-rev-widg__summary-average').text(currentValue);
        }, 1000);
    }

    /*FAQ section*/
    if($('.faq-question').length > 0) {
        document.querySelectorAll(".faq-question").forEach(function (question) {
            question.addEventListener("click", function () {
                this.closest(".faq-block").classList.toggle("faq-active-tab");
            });
        });
    }
});

$.fn.isInViewport = function () {
    let elementTop = $(this).offset().top;
    let elementBottom = elementTop + $(this).outerHeight();
    let viewportTop = $(window).scrollTop();
    let viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
};


function addToCartV1(variant_id, btn_id, redirect_to_cart = 0) {

    $(`#${btn_id}`).text('...');

    const data = {
        "id": variant_id,
        "quantity": 1
    }

    jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function () {
            setTimeout(function(){
                // if(redirect_to_cart == 1){
                    document.location.href="/cart";
                // } else {
                //     document.location.reload();
                // }
            },700);
        },
        error: function (error) {
            alert(error.responseJSON.message + '\r\n' + error.responseJSON.description);
        }
    });
}

function addToCartFromPDP(variant_id, btn_id, loadingText = 'Please wait...') {
    $(`#${btn_id}`).val(loadingText);

    let data = {};
    if(variant_id == 0){
         data = {
            "id":  $('.active-size-variant').data('variant-id'),
            "quantity": 1
        }
    } else {
        data = {
            "id": variant_id,
            "quantity": 1
        }
    }


    jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function () {
            //$(`#${btn_id}`).val('Thank you!');
            setTimeout(function () {
                if (typeof upSaleEnable != "undefined" && upSaleEnable == true) {
                    const cleanURL = window.location.origin + window.location.pathname;
                    document.location.href = `${cleanURL}#upsale=1`;
                    document.location.reload();
                } else {
                    document.location.href = '/cart';
                }
            }, 700);
        },
        error: function (error) {
            alert(error.responseJSON.message + '\r\n' + error.responseJSON.description);
        }
    });
}

function openContactSalePopup() {
    $('.notify-overflow').show();
    $('.notify-popup').show();
}
function closeContactSalePopup() {
    $('.notify-overflow').hide();
    $('.notify-popup').hide();
}